import { render, staticRenderFns } from "./PlayerWinloseDetail.vue?vue&type=template&id=983a3d7a&"
import script from "./PlayerWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./PlayerWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports